import GridDateFilter from "./GridDateFilter";
import GridTextFilter from "./GridTextFilter";
import React from "react";
import GridNumericFilter from "./GridNumericFilter";
import GridTextFuzzySearchFilter from "./GridTextFuzzySearchFilter";

export const GRID_FILTER_TYPE_DATE = 'date';
export const GRID_FILTER_TYPE_NUMERIC = 'numeric';
export const GRID_FILTER_TYPE_BACKEND_TEXT_STANDARD = 'text-standard-backend';
export const GRID_FILTER_TYPE_BACKEND_TEXT_DYNAMIC = 'text-dynamic-backend';
export const GRID_FILTER_TYPE_BOOLEAN = 'boolean';

export default ({filterOptions, addFilterValue, removeFilterValue, clearFilter, filtersApplied, setDateFilter, clearDateFilter, type, columnName}) => <React.Fragment>
    {
        (() => { switch(type) {
            case GRID_FILTER_TYPE_DATE:
                return <GridDateFilter {...{filtersApplied, setDateFilter, clearDateFilter}}/>;
            case GRID_FILTER_TYPE_NUMERIC:
                return <GridNumericFilter {...{filterOptions, addFilterValue, removeFilterValue, clearFilter}} />
            case GRID_FILTER_TYPE_BACKEND_TEXT_DYNAMIC:
                return <GridTextFuzzySearchFilter {...{filterOptions, addFilterValue, removeFilterValue, clearFilter, columnName}} />;
            default:
                return <GridTextFilter {...{filterOptions, addFilterValue, removeFilterValue, clearFilter}} />
        }})()
    }
</React.Fragment>;
